import React, {useEffect} from "react";
import styled from 'styled-components';
import errorImage from '../../../assets/images/errorimage.png';
import {createStructuredSelector} from "reselect";
import * as selectors from "../../../selectors";
import {connect} from "react-redux";
import {ReactComponent as MasketingOSLogo} from "../../../assets/images/marketingOS.svg";
import queryString from "query-string";
import {sendCalendarConnectSuccess} from "../../../actions";

const ErrorPageContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin-top: auto;
`;

const ErrorTitle = styled.div`
  font-family: "Poppins" !important;
  font-weight: 500;
  font-size: 18px;
  line-height: 24px;
  color: #12151A;
  margin-bottom: 4px;
`;

const ErrorDescription = styled.div`
  font-size: 14px;
  line-height: 22px;
  max-width: 546px;
  display: flex;
  align-items: center;
  text-align: center;
  color: #525F76;
  white-space: pre-wrap;
`;

const ErrorImage = styled.img`
  margin-bottom: 30px;
`

const ImplementationGuideLink = styled.a`
  color: #0061FF;
  text-decoration: none;
`

let IntegrationErrorPage = ({integrationErrorPageDetails, confirmCalendarConnectSuccess}) => {

    useEffect(() => {
        const search = window.location.search;
        const queryParams = queryString.parse(search);
        const token = queryParams && queryParams.integToken;
        const success = queryParams && queryParams.success;
        if(token && success === "true"){
            confirmCalendarConnectSuccess({metadata: {token}})
        }
    })

    return (
        <ErrorPageContainer>
            <MasketingOSLogo style={{position: "fixed", top: 10, left: 14}}/>
            <ErrorImage src={integrationErrorPageDetails?.image} />
            <ErrorTitle>{integrationErrorPageDetails?.header}</ErrorTitle>
            <ErrorDescription>{integrationErrorPageDetails?.subheader}</ErrorDescription>
            {integrationErrorPageDetails?.errorlink &&
            <ErrorDescription>For more information, check out our <ImplementationGuideLink href="https://university.zoominfo.com/learn/article/zoominfo-schedule-with-formcomplete" target="_blank">implementation guide.</ImplementationGuideLink></ErrorDescription>
            }
        </ErrorPageContainer>
    )
}

export const mapStateToProps = (state, props) => {
    return createStructuredSelector({
        integrationErrorPageDetails: selectors.makeSelectIntegrationErrorPageInfo(),
    });
};

export const mapDispatchToProps = dispatch => {
    return {
        confirmCalendarConnectSuccess : ({metadata}) => dispatch(sendCalendarConnectSuccess({metadata})),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(IntegrationErrorPage);